import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PersonIcon from '@mui/icons-material/Person';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Post } from '../../services/http';
import EmailIcon from '../../images/email.png';
import UserIcon from '../../images/design_useroutlined.png';
import TelIcon from '../../images/tel.png';
import WorldIcon from '../../images/bx_world.png';
import LocationIcon from '../../images/carbon_location-filled.png';
import MobIcon from '../../images/bi_phone-fill.png';
import EmIcon from '../../images/carbon_email.png';

export default function ContactUsPage() {
    const [campaigns, setCampaigns] = React.useState(false);
    const openInfoPopup = useStoreActions((actions) => actions.open);

    const send = async () => {
        const fromName = document.getElementById('fromName').value;
        const fromEmail = document.getElementById('fromEmail').value;
        const phone = document.getElementById('phone').value;
        const content = document.getElementById('content').value;
        console.log('fromName', fromName);
        const result = await Post('/api/donation/CreateContactUsItem', { fromName, fromEmail, phone, content });
        console.log('result', result);
        if (result.result) {
            openInfoPopup({ notice: 'הפניה נשלחה בהצלחה', reload: false });
        } else {
            openInfoPopup({ notice: result.message, reload: false });
        }
    };

    return (
        <main className="main bg-color" style={{ marginBottom: 10 }}>

            <section className="contacts" style={{ paddingTop: '60px', paddingBottom: '60px' }}>

                <h1 className="contacts__title _anim-items _fadeScale rubik f-normal weight-600 f-54 color-1" data-animate-delay="01">Contact Us</h1>
                <p style={{ marginTop: 80, marginBottom: '0' }} className="center-text f-16 rubik f-normal weight-600 color-5">Main {'>>'} <span className="color-1">Become a Member</span></p>

                <div className="contacts__path">
                <div className="container">
                        <div className="contacts-wrap">
                            <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="03">
                                <div className="contacts-wrap__icon">
                                <img src={WorldIcon} alt="" />
                                </div>
                                <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10 }}>
                                    <span className="weight-500">Mail:</span> P.o. Box 1003,Lakewood NJ 08701
                                </div>
                            </div>
                            <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="04">
                                <div className="contacts-wrap__icon">
                                <img src={LocationIcon} alt="" />
                                </div>
                                <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10 }}>
                                    <span className="weight-500">Address:</span>
                                    16 Bridgewood Ave,
                                    Lakewood NJ 08701
                                </div>
                            </div>
                            <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="05">
                                <div className="contacts-wrap__icon">
                                <img src={MobIcon} alt="" />
                                </div>
                                <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10, fontSize: '14px' }}>
                                    <span className="weight-500">Call or Text: </span>
                                    732-307-8182 <br />
                                    <span className="weight-500">WhatsApp:</span> Click here
                                </div>
                            </div>
                            <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="06">
                                <div className="contacts-wrap__icon">
                                <img src={EmIcon} alt="" />
                                </div>
                                <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10, fontSize: '14px' }}>
                                    <span className="weight-500">Email:</span>
                                    info@tomcheitzedaka.org
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section className="send section">
                <div className="container">
                    <div className="section__head">
                        <h2 className="section__title _anim-items  _fadeScale colof-1 weight-500 rubik f-28 f-normal" data-animate-delay="02"><span>Send us a message</span></h2>
                    </div>

                    <div className="send-form _anim-items  _fadeUp" data-animate-delay="04">
                        <div className="send-form__item">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={UserIcon} alt="" />
                                <input type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="fromName" placeholder="First Name" />
                            </div>
                        </div>
                        <div className="send-form__item">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={EmailIcon} alt="" />
                                <input type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="fromEmail" placeholder="E-mail" />
                            </div>
                        </div>
                        <div className="send-form__item">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={TelIcon} alt="" />
                                <input type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="phone" placeholder="Tel:" />
                            </div>
                        </div>
                        <div className="send-form__message">
                            <textarea className="border-none input color-4 weight-400 f-16 roboto f-normal" id="content" style={{ padding: 10, borderRadius: 10 }} placeholder="Message:" />
                        </div>
                        <div className="send-form__button">
                            <button style={{ width: '100%', background: '#1979BE', marginBottom: '30px' }} type="submit" className="btn-red" onClick={send}>Send</button>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
